/**
 * Model for Products
 *
 */
export class ProductsModel {
	id?: string;
	title?: string;
	active?: boolean;
	origin?: string;
	description?: string;
	inspection?: InspectionConfiguration;
	acuity?: TrackingSystemConfigurationInfo;
	nexsys?: TrackingSystemConfigurationInfo;
	appScope?: AppScopeTrakingConfigurationInfo;
	insideMaps?: InsideMapsTrakingConfigurationInfo;
	valutrust?: TrackingSystemConfigurationInfo;
	xpanse?: TrackingSystemConfigurationInfo;
	fnc?: TrackingSystemConfigurationInfo;
	integration?: TrackingSystemConfigurationInfo;
	createdBy?: UserInfo;
	created?: string;
	updatedBy?: UserInfo;
	updated?: string;
	subProductConfiguration?: SubProduct;
	licensingServiceSetting? : LicensingServiceSetting;
	channel?: string;
	isOrganizationLevel?: boolean;

	constructor() {
		this.active      = true;
		this.title       = '';
		this.description = '';
		this.inspection  = new InspectionConfiguration();
		this.insideMaps  = new InsideMapsTrakingConfigurationInfo();
		this.appScope    = new AppScopeTrakingConfigurationInfo();
		this.nexsys      = new TrackingSystemConfigurationInfo();
		this.acuity      = new TrackingSystemConfigurationInfo();
		this.valutrust   = new TrackingSystemConfigurationInfo();
		this.xpanse      = new TrackingSystemConfigurationInfo();
		this.fnc         = new TrackingSystemConfigurationInfo();
		this.integration = new TrackingSystemConfigurationInfo();
		this.subProductConfiguration = new SubProduct();
		this.licensingServiceSetting = new LicensingServiceSetting();
		this.isOrganizationLevel = false;
	}
}

export class InspectionConfiguration {
	enabled?: boolean;
	schema?: string;
	gsePreference?: string;
	keepInspection?: boolean;
	softwareCollector?: string;
	gseFungible?: boolean;
	disableFREDDIESubmition?: boolean;
	disableFNMASubmition?: boolean;
	useUPD?:boolean;
	injectImagesIntoForm?: boolean;
}

export class TrackingSystemConfigurationInfo {
	integrationId?: string;
	name?: string;
	enabled?: boolean;
	productId?: string;
	productName?: string;
	disableCommunications: boolean;
	isFhaProduct?: boolean;
	productAssetsId?: string;
	productAssetDescription?: string;
	defaultFhaNumber?: string;
	isDefaultProduct?: boolean;
	orderAttribute?: Array<string>;
	isOrderRentSchedule?: boolean;
	isOrderIncomeStatement?: boolean;
	bpoProduct?: boolean;
	bpoLinkTrigger?: string;
	is3dProduct: boolean;
	autoCompleteScopeOrderOption?: AutoCompleteScopeOrder;
	notifyAppscopeAcuityOrderEscalated?: boolean;
	invoice?: boolean;
	instance?: string;

	constructor() {
		this.autoCompleteScopeOrderOption = new AutoCompleteScopeOrder();
	}
}

export class AutoCompleteScopeOrder {
	autoComplete?: boolean;
	autoCompleteMilestoneTrigger?: string;
	uploadDocuments?: boolean;
	uploadDocumentsMilestone?: string;
	documents?: Array<DocumentScopeOrder>;

	constructor() {
		this.autoComplete = false;
		this.uploadDocuments = false;
		this.documents = [];
	}
}

class DocumentScopeOrder {
	documentSource?: string;
	documentType?: string;
	isFinalDocument?: boolean;
}

export class AppScopeTrakingConfigurationInfo {
	enabled?: boolean;
	jobId?: string;
	jobName?: string;
	disableCommunications?: boolean;
	enqueueCommunications?: boolean;
	borrowerEmailToComments?: boolean;
	creationTrigger?: string;
	creationStatusTrigger?: string;
	productAssetsId?: string;
	productAssetDescription?: string;
	associatedOrderProductName?: string;
	associatedOrderProductType?: string;
	enableAcuityFileSincronization?: boolean;
	invoice?: boolean;
}

export class InsideMapsTrakingConfigurationInfo {
	enabled?: boolean;
	insideMapsName?: string;
	insideMapsId?: string;
	insideMapsFee?: number;
	sendListingLink?: boolean;
	sendPropertyReportPageLink?: boolean;
}

export class UserInfo {
	id?: string;
	firstName?: string;
	lastName?: string;
}

export class SubProduct {
	products?: Array<SubProductInfo>;

	constructor () {
		this.products = [];
	}
}

export class SubProductInfo {
	id?: string;
	name?: string;
	subProductFee?: number;
	creationTrigger?: string;
	creationStatusTrigger?: string;
	hybridMode?: boolean;
}

export class TrakingListModel {
	id?: string;
	title?: string;
}
class AcuityCreationSetting {
	acuityProductId: string;
	acuityProductName: string;
	creationTrigger: string = 'IncomingOrder';
}

export class LineOfBussiness {
	id?: string;
	name?: string;
}

export class InvoiceOption {
	anable?: boolean;
}
export class ProductsData {
	id?: string;
	name?: string;
	subProductFee?: string = '0';
	creationTrigger?: string = 'Manage3DScan';
}
class SubProductConfiguration {
	products: Array<ProductsData>;

	constructor() {
		const productsData1 = new ProductsData();
		const productsData2 = new ProductsData();

		this.products = [
			productsData1,
			productsData2
		];
	}
}
export class LicensingServiceSetting {
	enabled: boolean = false;
	acuityCreationSetting: AcuityCreationSetting;
	subProductConfiguration: SubProductConfiguration;

	constructor() {
		this.acuityCreationSetting = new AcuityCreationSetting();
		this.subProductConfiguration = new SubProductConfiguration();
	}
}


export class ListOptions {
	id?: string;
	name?: string;
}
